import React, { useContext } from 'react';
import Context from '../../../../utils/context';
import ProgressBar from '../progress_bar';
import UserMenu from '../../../chrome/admin_header/user_menu';
import SurveyExitContext from '../../../../utils/survey_exit_context';
import QuestionnaireLocaleContext from '../../../questionnaire/locale_context';
import { interpolate } from '../../../../helpers/questionnaire_translations';

import styles from './index.module.css';

const ExitIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 256 256'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path d='M120,216a8,8,0,0,1-8,8H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h64a8,8,0,0,1,0,16H48V208h64A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z' />
  </svg>
);

const hasProgress = (current, total) => typeof current === 'number' && typeof total === 'number';

const LOGO_SRC = 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/svg/pp-logo.svg';

const QuestionWrapper = ({
  children,
  onSubmit,
  onBack,
  isDisabled = false,
  showNavButtons = true,
  wide = false,
  current,
  total,
}) => {
  const context = useContext(Context);
  const surveyExit = useContext(SurveyExitContext);
  const locale = useContext(QuestionnaireLocaleContext);
  const isMobile = context.viewport.getIsMobile();
  const isLoggedIn = context.auth.isLoggedIn();
  const showCounter = hasProgress(current, total);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof onSubmit === 'function') onSubmit(e);
  };

  const handleBack = (e) => {
    e.preventDefault();
    if (typeof onBack === 'function') onBack(e);
  };

  return (
    <div className={styles.root}>
      <div className={isMobile ? `${styles.topBar} ${styles.topBarMobile}` : styles.topBar}>
        <div className={isMobile ? `${styles.topBarLine} ${styles.topBarLineMobile}` : styles.topBarLine}>
          {isMobile || isLoggedIn ? (
            <span aria-hidden='true' />
          ) : (
            <img src={LOGO_SRC} alt='PatientPartner' className={styles.logo} />
          )}
          <div className={styles.topBarMiddle}>
            {showCounter && (
              <span className={styles.counter}>{interpolate(locale.chrome('progress'), { current, total })}</span>
            )}
          </div>
          <div className={styles.topBarControls}>
            {locale.switcher}
            {surveyExit?.onExit && (
              <button type='button' className={styles.exitButton} onClick={surveyExit.onExit}>
                <ExitIcon />
                <span>{locale.chrome('exit')}</span>
              </button>
            )}
            <UserMenu />
          </div>
        </div>
        {showCounter && (
          <div className={wide ? `${styles.progress} ${styles.progressWide}` : styles.progress}>
            <ProgressBar current={current} total={total} />
          </div>
        )}
      </div>
      <div className={styles.body}>
        <form className={wide ? `${styles.content} ${styles.contentWide}` : styles.content} onSubmit={handleSubmit}>
          {children}
          {showNavButtons && (
            <div className={styles.navButtons}>
              <button type='button' className={styles.back} onClick={handleBack}>
                {locale.chrome('back')}
              </button>
              <button type='submit' className={styles.submit} disabled={isDisabled}>
                {locale.chrome('next')}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default QuestionWrapper;
